import { post, get } from "./http";
import common from './constants';


let basic = common.interfacePath.serverTestUrl;
// basic += '';

// let basic = "/ngOrder";

const orderApi = {
  getOrderList: (params) => {
    return get(`/order/listOrder`, params);
  }, // 订单列表
  orderDetail: (params) => {
    return get(`/order/getOrderDetail`, params);
  }, // 订单详情
  cancel: (params) => {
    return post(`/order/cancelOrder`, params);
  }, // 订单取消

  //订单列表
  getListOrder: params => { return get(`${basic}/order/listOrder`, params); }, 
  //确认订单
  recheckOrder: params => { return post(`${basic}/order/recheckOrder`, params); }, 
  
};

export default orderApi;
